<top-banner variant="custom">
    <h2 class="title mb-3">Site Owners</h2>
    <button type="button" (click)="toggleCreateUserModal();" class="btn color_blue-btn btn-round"><i class="fas fa-plus"></i>
      &nbsp;
      <strong>CREATE NEW SITE OWNER</strong>
    </button>
</top-banner>


<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <div class="form-row">
            <!-- Search and Sorting/Filter sidemenu button to be implemented here -->
            <div class="col-md-9">
              <select class="form-control my-3" style="width: auto;" [(ngModel)]="selectedSort" (ngModelChange)="sortChange($event)">
                <option *ngFor="let option of sortFields" [ngValue]="option">
                  {{option.sortName}}
                </option>
              </select>
                <div class="form-group form-group-checkbox">
                  <label>Show disabled site owners</label>
                  <p-checkbox class="form-control" [(ngModel)]="showDisabledSiteOwners" binary="true"></p-checkbox>
                </div>
            </div>
            <div class="col-md-3"></div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <p-table [value]="showDisabledSiteOwners ? users : enabledOnlyUsers" selectionMode="single" [(selection)]="selectedUser" (onRowSelect)="onRowSelect($event)" [autoLayout]="true">
                <ng-template pTemplate="header">
                  <tr>
                    <th *ngIf="showDisabledSiteOwners">Enabled</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Username</th>
                    <th>Max Sites</th>
                    <th>Add Assets</th>
                    <th>Check-On Site Form</th>
                    <th>Check-Off Site Form</th>
                    <th>Restrictions Workflow</th>
                    <th>Work Order Scheduling</th>
                    <th>Asset Scheduling</th>
                    <th>Incident Reporting</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-user>
                  <tr [pSelectableRow]="user">
                    <td *ngIf="showDisabledSiteOwners">
                      <ng-template *ngTemplateOutlet="enabledDisabled; context: {$implicit: user.siteOwnerUser.enabled}"></ng-template>
                    </td>
                    <td>{{user.firstName}}</td>
                    <td>{{user.lastName}}</td>
                    <td>{{user.email}}</td>
                    <td>{{user.login}}</td>
                    <td>{{user.siteOwnerUser.maxSiteCount}}</td>
                    <td>
                      <ng-template *ngTemplateOutlet="enabledDisabled; context: {$implicit: user.siteOwnerUser.addAssets}"></ng-template>
                    </td>
                    <td>
                      <ng-template *ngTemplateOutlet="enabledDisabled; context: {$implicit: user.siteOwnerUser.allowCompulsoryCheckOnSiteForm}"></ng-template>
                    </td>
                    <td>
                      <ng-template *ngTemplateOutlet="enabledDisabled; context: {$implicit: user.siteOwnerUser.allowCompulsoryCheckOffSiteForm}"></ng-template>
                    </td>
                    <td>
                      <ng-template *ngTemplateOutlet="enabledDisabled; context: {$implicit: user.siteOwnerUser.allowRestrictionsWorkflow}"></ng-template>
                    </td>
                    <td>
                      <ng-template *ngTemplateOutlet="enabledDisabled; context: {$implicit: user.siteOwnerUser.allowWorkOrderScheduling}"></ng-template>
                    </td>
                    <td>
                      <ng-template *ngTemplateOutlet="enabledDisabled; context: {$implicit: user.siteOwnerUser.allowAssetScheduling}"></ng-template>
                    </td>
                    <td>
                      <ng-template *ngTemplateOutlet="enabledDisabled; context: {$implicit: user.siteOwnerUser.allowIncidentReporting}"></ng-template>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="7">
                      No users found
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <p-paginator #paginator [rows]="pagination.size" [totalRecords]="pagination.totalRecords" [rowsPerPageOptions]="pageSizes" (onPageChange)="paginate($event)"></p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #enabledDisabled let-enabled>
  <span *ngIf="enabled"><i class="fas fa-check-circle success"></i></span>
  <span *ngIf="!enabled"><i class="fas fa-times-circle danger"></i></span>
</ng-template>

<p-dialog header="New Site Owner" [(visible)]="createUserModal" modal="true" [baseZIndex]="1000000">
  <form [formGroup]="createUserForm" (ngSubmit)="onCreateUserFormSubmit()">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>First Name</label>
          <input type="text" class="form-control" formControlName="firstName" placeholder="">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Last Name</label>
          <input type="text" class="form-control" formControlName="lastName" placeholder="">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Email</label>
          <input type="email" class="form-control" formControlName="email" placeholder="">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Login</label>
          <input type="text" class="form-control" formControlName="login" placeholder="">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Max No. of Sites</label>
          <input type="number" min="1" max="200" value="1" class="form-control" formControlName="maxSiteCount">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group form-group-checkbox">
          <label>Allow adding assets?</label>
          <p-checkbox class="form-control" formControlName="addAssets" binary="true"></p-checkbox>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group form-group-checkbox">
          <label>Allow compulsory check-on site form?</label>
          <p-checkbox class="form-control" formControlName="allowCompulsoryCheckOnSiteForm" binary="true"></p-checkbox>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group form-group-checkbox">
          <label>Allow compulsory check-off site form?</label>
          <p-checkbox class="form-control" formControlName="allowCompulsoryCheckOffSiteForm" binary="true"></p-checkbox>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group form-group-checkbox">
          <label>Allow restrictions workflow?</label>
          <p-checkbox class="form-control" formControlName="allowRestrictionsWorkflow" binary="true"></p-checkbox>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group form-group-checkbox">
          <label>Allow scheduled work orders?</label>
          <p-checkbox class="form-control" formControlName="allowWorkOrderScheduling" binary="true"></p-checkbox>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group form-group-checkbox">
          <label>Allow scheduling asset availability?</label>
          <p-checkbox class="form-control" formControlName="allowAssetScheduling" binary="true"></p-checkbox>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group form-group-checkbox">
          <label>Allow incident reporting?</label>
          <p-checkbox class="form-control" formControlName="allowIncidentReporting" binary="true"></p-checkbox>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group form-group-checkbox">
          <label>Enabled</label>
          <p-checkbox class="form-control" formControlName="enabled" binary="true"></p-checkbox>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Password</label>
          <input type="password" class="form-control" formControlName="password" placeholder="">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Repeat Password</label>
          <input type="password" class="form-control" formControlName="rPassword" placeholder="">
        </div>
      </div>
      <div class="col-md-12">
        <p-messages [(value)]="errorAlerts"></p-messages>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="createUserModal=false" class="my-2 btn btn-round btn-sm  btn-default float-left">Cancel</button>
    <button type="button" (click)="onCreateUserFormSubmit()" [disabled]="!createUserForm.valid" class="my-2 btn btn-round btn-sm btn-success">Create</button>
  </p-footer>
</p-dialog>

<p-dialog header="Edit Site Owner" [(visible)]="editUserModal" modal="true" [baseZIndex]="1000000">
  <form [formGroup]="editUserForm" (ngSubmit)="onEditUserFormSubmit()">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>First Name</label>
          <input type="text" class="form-control" formControlName="firstName" placeholder="">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Last Name</label>
          <input type="text" class="form-control" formControlName="lastName" placeholder="">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Email</label>
          <input type="email" class="form-control" formControlName="email" placeholder="">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Username</label>
          <input type="text" class="form-control" formControlName="login" placeholder="">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Max No. of Sites</label>
          <input type="number" class="form-control" formControlName="maxSiteCount" placeholder="">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group form-group-checkbox">
          <label>Allow adding assets?</label>
          <p-checkbox class="form-control" formControlName="addAssets" binary="true"></p-checkbox>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group form-group-checkbox">
          <label>Allow compulsory check-on site form?</label>
          <p-checkbox class="form-control" formControlName="allowCompulsoryCheckOnSiteForm" binary="true"></p-checkbox>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group form-group-checkbox">
          <label>Allow compulsory check-off site form?</label>
          <p-checkbox class="form-control" formControlName="allowCompulsoryCheckOffSiteForm" binary="true"></p-checkbox>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group form-group-checkbox">
          <label>Allow restrictions workflow?</label>
          <p-checkbox class="form-control" formControlName="allowRestrictionsWorkflow" binary="true"></p-checkbox>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group form-group-checkbox">
          <label>Allow scheduled work orders?</label>
          <p-checkbox class="form-control" formControlName="allowWorkOrderScheduling" binary="true"></p-checkbox>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group form-group-checkbox">
          <label>Allow scheduling asset availability?</label>
          <p-checkbox class="form-control" formControlName="allowAssetScheduling" binary="true"></p-checkbox>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group form-group-checkbox">
          <label>Allow incident reporting?</label>
          <p-checkbox class="form-control" formControlName="allowIncidentReporting" binary="true"></p-checkbox>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group form-group-checkbox">
          <label>Enabled</label>
          <p-checkbox class="form-control" formControlName="enabled" binary="true"></p-checkbox>
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="editUserModal=false" class="my-2 btn btn-round btn-sm  btn-default float-left">Cancel</button>
    <button type="button" (click)="onEditUserFormSubmit()" [disabled]="!editUserForm.valid" class="my-2 btn btn-round btn-sm btn-success">Save</button>
  </p-footer>
</p-dialog>
